/**
 * @module app.track.list
 */
import appBase from '../index.js';
import {onRendered} from "../utils";
import {TRACK_FILTER_ID} from "../constants";


class Controller {
  /**
   * @param {jQuery} $element
   * @param {app.AuthenticationService} appAuthenticationService
   * @param {!app.CesiumLoader} appCesiumLoader
   * @param {app.track.filterService} appTrackFilterService
   * @param {angularGettext.Catalog} gettextCatalog Gettext catalog.
   * @ngInject
   */
  constructor($element, appAuthenticationService, appCesiumLoader, appTrackFilterService, gettextCatalog) {
    /**
     * @private
     */
    this.authentication_ = appAuthenticationService;

    this.loginConfig = this.authentication_.loginConfig;

    /**
     * @private
     */
    this.cesiumLoader_ = appCesiumLoader;

    /**
     * @private
     */
    this.trackFilterService_ = appTrackFilterService;

    /**
     * @type {angularGettext.Catalog}
     */
    this.gettextCatalog = gettextCatalog;

    /**
     * @type {Array}
     * @export
     */
    this.trackList = [];

    // scroll the list to the selected track
    onRendered($element, () => {
      const container = $element.find('.tracks-list');
      const target = container.find(':checked');
      if (target.length === 1) {
        // scroll to the element
        const top = target.offset().top - container.offset().top + container.scrollTop();
        container.scrollTop(+top);
      }
    });
  }

  /**
   * @export
   * @param {appx.TrackFilter} filter
   */
  filterTrackList(filter) {
    this.trackFilterService_.trackListFilter = filter;
  }

  /**
   * @export
   */
  filteredTrackList() {
    console.assert(this.trackList);
    let filterCondition;
    switch (this.trackFilterService_.trackListFilter.id) {
      case TRACK_FILTER_ID.ALL:
        filterCondition = () => true;
        break;
      case TRACK_FILTER_ID.OTHER:
        filterCondition = (id) => (
          id === null || id === undefined || id === TRACK_FILTER_ID.OTHER
        );
        break;
      default:
        filterCondition = (id) => id === this.trackFilterService_.trackListFilter.id;
        break;
    }
    return this.trackList.filter(track => filterCondition(track.filter_id));
  }

  /**
   * @export
   * @return {boolean}
   */
  loggedIn() {
    return this.authentication_.loggedIn;
  }

  /**
   * @export
   */
  logout() {
    this.authentication_.logout();
  }

  /**
   * @export
   */
  showGpsImportModal() {
    $('#gps_import_modal').modal('show');
  }
}

/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'onSelectTrack': '&',
    'selectedTrackId': '<',
    'trackList': '<',
  },
  controller: Controller,
  templateUrl: 'js/app/track/list/partial.html',
};

export default appBase.component('appTrackList', component);
